import { Stack } from '@mui/material';
import EmailEditor, { EmailEditorProps } from 'react-email-editor';
import { useMemo } from 'react';
import useContactColumns from 'hooks/queries/useContactColumns';
import { getUnlayerMergeTags } from 'utils';
import defaultDesign from './defaultDesign.json';

const DirectMailEditor = ({ editorRef }: any) => {
    const { data: contactColumns, isSuccess: isContactColumnsSuccess } = useContactColumns();

    const mergeTags = useMemo(() => {
        if (isContactColumnsSuccess) return getUnlayerMergeTags(contactColumns);
    }, [contactColumns, isContactColumnsSuccess]);

    const onLoad: EmailEditorProps['onLoad'] = (unlayer) => {
        // TODO: figure out types here - should be JSONTemplate but not sure how to access that
        // @ts-ignore
        unlayer.loadDesign(defaultDesign);
    };

    const onReady: EmailEditorProps['onReady'] = (unlayer) => {
        // TODO: determine if/how we want to use this functionality
        // editor is ready
        // you can load your template here;
        // the design json can be obtained by calling
        // unlayer.loadDesign(callback) or unlayer.exportData(callback)
        // const templateJson = { DESIGN JSON GOES HERE };
        // unlayer.loadDesign(templateJson);
    };

    return (
        <Stack height="100%" mt="20px">
            <EmailEditor
                ref={editorRef}
                onLoad={onLoad}
                onReady={onReady}
                options={{
                    appearance: {
                        panels: {
                            tools: {
                                dock: 'left',
                            },
                        },
                    },
                    features: { preview: false },
                    displayMode: 'document',
                    mergeTags,
                    // TODO: might need to create a separate workspace for this eventually
                    projectId: 3990,
                }}
            />
        </Stack>
    );
};

export default DirectMailEditor;
